import { observer } from "mobx-react-lite";

import { useAddActionModalState } from "./add-modal.state";
import { AddActionModalView } from "./add-modal.view";

export const AddActionModal = observer(() => {
  const state = useAddActionModalState();
  return <AddActionModalView state={state} />;
});
